import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
})

var i = 0

router.beforeEach((to, from, next) => {
  console.log(i)
  if (i >= 1) {

    window.location.href = to.fullPath
  }
  i++
  next()

})

export default router

export { routes }
